import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import vClickOutside from 'v-click-outside'
import vMediaQuery from 'v-media-query'
import vueSmoothScroll from 'vue2-smooth-scroll'
import bugsnagVue from 'bugsnag-vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import 'smartbanner.js'
import 'smartbanner.js/dist/smartbanner.min.css'

import App from './App.vue'
import router from './router'
import firebase from './firebase'
import store from './store'
import './registerServiceWorker'
import bugsnagClient from './bugsnag'
import mobileDetect from './plugins/mobileDetect'

const isProd = process.env.NODE_ENV === 'production'

Vue.config.productionTip = isProd

bugsnagClient.use(bugsnagVue(Vue))

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
  router,
  debug: {
    enabled: !isProd,
  }
})

Vue.use(Buefy, {
  defaultIconPack: 'fas',
})

Vue.use(vClickOutside)

const MOBILE_BREAKPOINT = 768
Vue.use(vMediaQuery, {
  methods: {
    isMobile() {
      return this.below(MOBILE_BREAKPOINT)
    }
  },
  variables: {
    mobile: MOBILE_BREAKPOINT
  }
})

Vue.use(vueSmoothScroll)

Vue.use(mobileDetect)

const unsubscribe = firebase.auth()
  .onAuthStateChanged((firebaseUser) => {
    new Vue({
      router,
      store,
      render: h => h(App),
      created() {
        if (firebaseUser) {
          store.dispatch('onUserLogin', { user: firebaseUser })
        }
      },
    }).$mount('#app')
    unsubscribe()
  })
